import { AnimatePresence, motion } from "framer-motion"
import { useEffect, useRef } from "react";
import { usePrompt } from "../../context/PromptContext";
import { X,InfoIcon,LogOutIcon } from "lucide-react";
import './appprompt.scss';

const AppPrompt=()=>{
    const { isPromptOpen,message,title,promptType,closePrompt,callbackFunc} = usePrompt();

 const promptBox = useRef<HTMLDivElement>(null)

     useEffect(() => {

        if(isPromptOpen){
            const handleClickOutside = (event: MouseEvent) => {
                if (
                    isPromptOpen &&
                    promptBox.current &&
                    !promptBox.current.contains(event.target as Node)) {
    
                    closePrompt()
                }
            }
    
            
    
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }    
        // eslint-disable-next-line
        }, [isPromptOpen]);

    const handleConfirm=()=>{
        if(callbackFunc){
            callbackFunc()
            closePrompt()
        }else{
            closePrompt()  
        }
    }


    return( <AnimatePresence>
        {isPromptOpen && (
            <motion.div className='promptSection'
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >

                <motion.div className="auth-modal"
                    initial={{ scale: 0.8, opacity: 0, }}
                    animate={{ scale: 1, opacity: 1, }}
                    exit={{ scale: 0.9, opacity: 0, }}
                    transition={{ type: "spring", stiffness: 500, damping: 20 }}

                    ref={promptBox}
                >

                    <div>

                        <button className="close-button" onClick={()=>closePrompt()} >
                            <X size={20}></X>
                        </button>


                        <div className='icon_enter'>
                            {promptType==='default' && (<InfoIcon size={35}></InfoIcon>)}
                            {promptType==='logout' && (<LogOutIcon size={35}></LogOutIcon>)}
                            </div>

                        <div className='title'>{title}</div>
                        {message && (<div className='text'>{message}</div>)}
                       
                        <div className="button-group">
                            <div className={`btn ${promptType}`} onClick={handleConfirm}>
                            {promptType==='default' && ('Confirm')}
                            {promptType==='logout' && ('Log out')}
                                
                                </div>
                            <div className='btn open' onClick={()=>closePrompt()}>Cancel</div>
                        </div>

                    </div>

                </motion.div>

            </motion.div>
        )}

    </AnimatePresence>)
}


export default AppPrompt;